import { StreamingVideoPlayer } from './streaming-video-player';
import { debounceTime } from 'rxjs/operators';
/*
    WARNING: Setting delay to zero can cause tracking issues for the end event,
    caused by switching videos before tracking's ended event is handled
*/
export class PlaylistVideoPlayer extends StreamingVideoPlayer {
    constructor(containerEl, playlist = [], trackingSettings, initialVideo = null) {
        super(containerEl, (initialVideo || playlist[0]), trackingSettings);
        this._playlist = playlist;
        this._loop = false; // true: load first video after last video ends
        this._delay = 1000; // time in milliseconds it takes to switch to next video after current video ends

    }
    get delay() {
        return this._delay;
    }
    set delay(val = 1000) {
        this._delay = val;
    }
    get loop() {
        return this._loop;
    }
    set loop(flag = false) {
        this._loop = flag;
    }
    get playlist() {
        return this._playlist;
    }
    init() {
        super.init();
        let endedSubscription = this.amp.AmpEventsSources.ended
            .pipe(debounceTime(this.delay))
            .subscribe(eventData => {
                this.handleVideoEnd(eventData);
            });
        this.subscriptions.push(endedSubscription);
    }
    handleVideoEnd(eventData) {
        let { videoId } = eventData;
        const videoIndex = this.playlist.findIndex(videoConfig => {
            return videoConfig.videoId == videoId;
        });
        let nextVideo = this.playlist[videoIndex + 1] == null && this.loop ? this.playlist[0] : this.playlist[videoIndex + 1];

        if (nextVideo != null) {
            this.setMedia(nextVideo);
        }
    }
}